import {NativeDateAdapter} from '@angular/material';
import * as moment from 'moment';

export class MaterialYearPickerDateAdapter extends NativeDateAdapter {

    parse(value: any): Date | null {
        if (value && value.length <= 4) {
            return null;
        }
        return super.parse(value);
    }

    getFirstDayOfWeek(): number {
        return 1;
    }

    format(date: Date, displayFormat: string): string {
        return moment(date).format(displayFormat);
    }

}
